import { render, staticRenderFns } from "./AccomTabsNotes.vue?vue&type=template&id=567851c9&scoped=true&"
import script from "./AccomTabsNotes.vue?vue&type=script&lang=js&"
export * from "./AccomTabsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567851c9",
  null
  
)

export default component.exports